// 비밀번호 찾기 페이지 JavaScript

// 탭 전환 기능
function switchTab(tabType) {
  // 모든 탭 버튼 비활성화
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.classList.remove('active');
  });
  
  // 모든 탭 콘텐츠 숨김
  document.querySelectorAll('.tab-content').forEach(content => {
    content.classList.remove('active');
    content.style.display = 'none';
  });
  
  // 선택된 탭 활성화
  event.target.classList.add('active');
  const selectedTab = document.getElementById(tabType + 'Tab');
  selectedTab.classList.add('active');
  selectedTab.style.display = 'block';
}

// 회원 정보 확인 (더미 데이터)
function verifyMemberInfo(userId, contact, isPhone) {
  const memberData = [
    {
      userId: 'custom1',
      name: 'custom1',
      phone: '010-1234-5678',
      email: 'hong@example.com'
    },
    {
      userId: 'kimcs2024',
      name: '김철수',
      phone: '010-9876-5432',
      email: 'kim@example.com'
    }
  ];
  
  return memberData.some(member => {
    const userIdMatch = member.userId === userId;
    const contactMatch = isPhone ? 
      member.phone === contact : 
      member.email === contact;
    
    return userIdMatch && contactMatch;
  });
}

// 폼 제출 처리
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('findPasswordForm');
  
  if (!form) {
    // 비밀번호 찾기 페이지가 아님 - 조용히 종료
    return;
  }
  
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const activeTab = document.querySelector('.tab-content.active');
    const isPhoneTab = activeTab.id === 'phoneTab';
    
    let userId, contact;
    
    if (isPhoneTab) {
      userId = document.getElementById('userId').value.trim();
      contact = document.getElementById('phone').value.trim();
    } else {
      userId = document.getElementById('userId2').value.trim();
      contact = document.getElementById('email').value.trim();
    }
    
    // 입력 검증
    if (!userId || !contact) {
      alert('모든 항목을 입력해주세요.');
      return;
    }
    
    // 회원 정보 확인
    if (!verifyMemberInfo(userId, contact, isPhoneTab)) {
      alert('입력하신 정보가 일치하지 않습니다.\n다시 확인해주세요.');
      return;
    }
    
    // 정보가 일치하면 비밀번호 재설정 페이지로 이동
    // userId를 쿼리 파라미터로 전달
    sessionStorage.setItem('resetUserId', userId);
    window.location.href = 'auth-reset-password.html';
  });
});

// 전화번호 자동 포맷팅
document.addEventListener('DOMContentLoaded', function() {
  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  
  phoneInputs.forEach(input => {
    input.addEventListener('input', function(e) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      
      if (value.length >= 3 && value.length <= 7) {
        value = value.replace(/(\d{3})(\d+)/, '$1-$2');
      } else if (value.length >= 8) {
        value = value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
      }
      
      e.target.value = value;
    });
  });
});
